// A fast string hash (cyrb53's mixing), the same in Node and browsers: for noticing that something changed (a PO's
// printed fields, the plan check's differences, a spec's draft), never for security.

/** The hash's two 32-bit halves. */
function halves(s: string): [number, number] {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    h1 = Math.imul(h1 ^ c, 2654435761);
    h2 = Math.imul(h2 ^ c, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return [h1, h2];
}

/** cyrb53 itself: 53 bits in base 36. */
export function hash53(s: string): string {
  const [h1, h2] = halves(s);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
}

/** All 64 bits, in hex. */
export function hash64(s: string): string {
  const [h1, h2] = halves(s);
  return (h2 >>> 0).toString(16).padStart(8, "0") + (h1 >>> 0).toString(16).padStart(8, "0");
}
